import React from 'react'
import { icons, Place } from '../PlaceIcon/icons'
import companyicon from '../../assets/icons/Companyicon.svg';
interface Props {
    style?: React.CSSProperties
    name?: Place
    url?:string
}



export const PlaceIcon: React.FC<Props> = (props) => {

    return (<img src={props.name?icons[props.name as keyof typeof icons]:props.url?props.url:companyicon} alt='place' style={props.style}/>)
}